<div
  class="dashboard-dock"
  [class.dashboard-dock--active]="isDockDragOver()"
  (dragover)="onDockDragOver($event)"
  (dragleave)="onDockDragLeave($event)"
  (drop)="onDockDrop($event)"
>
  <div class="dashboard-dock__inner">
    @for (item of dockRenderItems(); track item.key + '-' + $index) {
      @if (item.isPlaceholder) {
        <div class="dashboard-dock__placeholder">{{ 'ProjectsDashboard.dock.dropHere' | translate }}</div>
      } @else {
        <div
          class="dashboard-dock__item"
          data-dock-item="real"
          draggable="true"
          [class.dashboard-dock__item--active]="isDockItemActive(item.key)"
          [class.dashboard-dock__item--new]="item.isNew"
          (click)="onDockItemClick(item)"
          (mouseenter)="onDockItemMouseEnter(item.key)"
          (mouseleave)="onDockItemMouseLeave(item.key)"
          (dragstart)="onDockItemDragStart($event, item, $index)"
          (dragend)="onDockItemDragEnd()"
        >
          @if (trashVisibleItemKey() === item.key && isRemovableDockItem(item.key)) {
            <span class="dashboard-dock__item-trash" (click)="onDockItemRemove($event, item.key)">
              <svg-icon src="/assets/img/ic-trash-outline-red.svg" />
            </span>
          }
          <svg-icon [src]="item.icon || '/assets/img/dashboard-icon.svg'" draggable="false" />
          <span draggable="false">{{ item.label }}</span>
        </div>
      }
    }
  </div>
</div>

@if (activeDrag()) {
  <div class="dashboard-dock__drag-ghost" [style.left.px]="dragCursor().x" [style.top.px]="dragCursor().y">
    <svg-icon [src]="activeDrag()?.item?.icon || '/assets/img/dashboard-icon.svg'" />
    <span>{{ activeDrag()?.item?.label }}</span>
  </div>
}
